export default __webpack_public_path__ + "static/media/blob4.e1d5127d.svg";